import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from "@ngx-translate/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { roleszService } from 'src/app/services/accountssetting/roleslist.service';
import { IResultroleszModel, IroleszModel } from 'src/app/models/accounts/role.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-filter-selectrole',
  templateUrl: './filter-selectrole.component.html',
  styleUrls: ['./filter-selectrole.component.scss']
})
export class FilterselectroleComponent {
  frmFilter: FormGroup;
  resultRole: IroleszModel[] = [];
  role: any;
  
  @Input() account_id: any;
  @Input() rolename: any; // ID of the role to be preselected

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    public modal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private roleService: roleszService
  ) {
    // Initialize the form
    this.frmFilter = this.fb.group({
      role: [null]
    });
  }

  ngOnInit(): void {
    this.loadRoles();
  }

  loadRoles(): void {
    // Fetch roles from the service
    this.roleService.getroleslist(localStorage.getItem("practiceId") || '').subscribe({
      next: (data: IResultroleszModel) => {
        this.resultRole = data.results;
        
        // Set the preselected role based on roleId
        const matchingRole = this.resultRole.find(role => role.name === this.rolename);
        if (matchingRole) {
          this.frmFilter.patchValue({
            role: matchingRole.id // Set the ID of the matching role
          });
        }
        
    
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error fetching roles:', error);
        this.resultRole = [];
      }
    });
  }

  onRolesSelected(event: any): void {
    this.roleService.changuserrole(this.account_id, event.value, localStorage.getItem("practiceId") || '0').subscribe({
      next: () => {
        Swal.fire('Success', 'Account role changed successfully.', 'success');

        this.modal.close(); // Close the modal after updating role
      },
      error: (error) => {
        console.error('Error changing user role:', error);
      }
    });
  }

  filter(): void {
    this.modal.close({ role: this.role });
  }

  clearFilter(): void {
    this.frmFilter.reset();
    this.role = '';
  }
}
